import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  useTheme,
} from '@mui/material';

interface IFAQSection {
  faqs: Record<string, any>[];
}

const FAQSection = ({ faqs }: IFAQSection) => {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="2rem"
      alignItems="center"
      justifyContent="center"
      margin="0 auto"
      sx={{
        width: '100%',
      }}
    >
      <Typography variant="h5" color="secondary" fontWeight={theme.typography.fontWeightMedium}>
        Preguntas <span style={{ color: theme.palette.primary.main }}>más buscadas</span> por
        nuestros usuarios
      </Typography>
      <Box sx={{ width: '100%' }}>
        {faqs.map((faq) => (
          <Accordion sx={{ width: '100%', m: 0 }} key={faq.id}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} id={faq.id.toString()}>
              <Typography component="h6" fontWeight={theme.typography.fontWeightMedium}>
                {faq.faqTitle}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: { xxs: '0 1rem 2rem', md: '0 3rem 2rem' },
                color: theme.palette.grey[600],
              }}
            >
              {faq.htmlContent}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default FAQSection;
